<div>
  @if (loading) {
  <bergh-loader></bergh-loader>
  }
  <div class="row">
    <div class="col-3 form-group">
      <label>Registratiestatus</label>
      <ng-multiselect-dropdown
        [settings]="dropdownSettings"
        [placeholder]="'Kies status'"
        [data]="fpStatuses"
        [(ngModel)]="selectedFpStatuses"
      >
      </ng-multiselect-dropdown>
    </div>
    <div class="col-2 form-group">
      <label>Materiaalstatus</label>
      <ng-multiselect-dropdown
        [settings]="dropdownSettings"
        [placeholder]="'Kies status'"
        [data]="materialStatuses"
        [(ngModel)]="selectedMaterialStatuses"
      >
      </ng-multiselect-dropdown>
    </div>
    <div class="col-3 form-group">
      <label>Soort</label>
      <ng-multiselect-dropdown
        [settings]="dropdownSettings"
        [placeholder]="'Kies soort'"
        [data]="fpTypes"
        [(ngModel)]="selectedTypes"
      >
      </ng-multiselect-dropdown>
    </div>
    <div class="col-2 form-group">
      <label>Meerwerk</label>
      <select
        class="form-control"
        id="ddwn-extrawork"
        [(ngModel)]="selectedExtraWork"
      >
        <option id="optionDefault" value="null" selected>Kies meerwerk</option>
        <option id="option1" value="true">Ja</option>
        <option id="option2" value="false">Nee</option>
      </select>
    </div>
    <div
      class="col-2 d-flex align-items-center justify-content-between mb-3 mt-4"
    >
      <h5 class="bergh-text-primary m-0"></h5>
      <button
        class="btn bergh-btn-secondary text-white"
        (click)="getAvailableFpForMaterialTab()"
      >
        Filter toepassen
      </button>
    </div>
    <table class="table table-striped card-body col-12">
      <thead>
        <tr class="row">
          <th class="col-3 pl-4" scope="col">Registratie</th>
          <th class="col-2 pl-3" scope="col">Materiaal</th>
          <th class="col-3 pl-3" scope="col">Eigenschap</th>
          <th class="col-3 pl-3" scope="col">Opmerkingen</th>
          <!--        <th class="col-3 pl-3" scope="col">Status</th>-->
          <th class="col-1 pl-3" scope="col">Aantal</th>
        </tr>
      </thead>
      <tbody>
        @for (material of materialsList; track material) {
        <tr class="row">
          <td class="col-3 text-small pl-4">
            <div class="text-truncate align-items-center">
              {{ material.firePartitionCode }}
            </div>
          </td>
          <td class="col-2 text-small pl-3">
            <div class="d-flex col-2 align-items-center">
              {{ material.materialType.nameDutch }}
            </div>
          </td>
          <td class="col-3 text-small pl-4">
            @if (material.materialSpecification!== null) {
            <div class="d-flex col-2 align-items-center">
              {{ material.materialSpecification.nameDutch }}
            </div>
            } @if (material.materialType.specificationType === 'MAINTENANCE') {
            <div>
              {{ (material.materialPlacedDate | date : "dd-MM-yyyy") ?? "-" }}
              :
              {{
                (material.materialMaintenanceDate | date : "dd-MM-yyyy") ?? "-"
              }}
              {{
                material.materialMaintenanceIntervalMonths &&
                  "(" + material.materialMaintenanceIntervalMonths + ")"
              }}
            </div>
            }
          </td>
          <td class="col-3 text-small pl-3">
            <div class="d-flex align-items-center">
              {{ material.materialRemarks }}
            </div>
          </td>
          <!--        <td class="col-1 text-small pl-3">-->
          <!--            <div class="d-flex col-1 align-items-center">-->
          <!--              {{ material.materialStatus ? material.materialStatus.nameDutch : material.firePartitionStatus?.nameDutch }}-->
          <!--            </div>-->
          <!--          </td>-->
          <td class="col-1 text-small pl-3">
            <div class="d-flex col-1 align-items-center">
              {{ material.noOfUnits }}
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>
